import { NgModule } from '@angular/core';
import { ChangePasswordCodeComponent } from './change-password-code/change-password-code.component';
import { PasswordManagerNavComponent } from './password-manager-nav/password-manager-nav.component';
import { TranslateModule } from '@ngx-translate/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatToolbarModule} from '@angular/material/toolbar';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { ForgotPasswordCodeComponent } from './forgot-password-code/forgot-password-code.component';
import { ApiService } from './api.service';

@NgModule({
  declarations: [
    ForgotPasswordCodeComponent,
    PasswordManagerNavComponent,
    ChangePasswordCodeComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule
  ],
  exports: [
    ChangePasswordCodeComponent, PasswordManagerNavComponent,ForgotPasswordCodeComponent
  ]
})
export class PasswordManagerModule { }
